import { ListView } from '@progress/kendo-react-listview';

/**
 * A single list component that wraps Kendo's ListView component.
 * This component is used to create lists with various styles.
 * 
 * @component
 * @param {Object} props - properties passed to component.
 * @param {string} props.className - additional CSS classes to apply to list header.
 * @param {array} props.data - data items to be rendered in list.
 * @param {React.ComponentType<any>} props.footer - optional footer component to render at the bottom of the list.
 * @param {React.ComponentType<any>} props.header - optional header component to render at the top of the list.
 * @param {React.ComponentType<ListViewItemProps>} props.item - optional item component to render each list item.
 * @param {boolean} props.navigatable - whether list items are navigable.
 * @param {function} props.onScroll - callback function for scroll events.
 * @param {string} props.style - inline styles to apply to list header.
 * @returns {JSX.Element}
 * 
 * @see {@link https://www.telerik.com/kendo-react-ui/components/listview | KendoReact ListView Documentation}
 * 
 */
export const List = ({
  className = '',
  data = [],
  footer: FooterComponent,
  header: HeaderComponent,
  item: ItemComponent,
  navigatable = false,
  onScroll = () => { },
  style = {},
}) => {
  return (
    <ListView
      data={data}
      className={className}
      style={style}
      navigatable={navigatable}
      onScroll={onScroll}
      header={HeaderComponent ? HeaderComponent : null}
      footer={FooterComponent ? FooterComponent : null}
      item={
        ItemComponent ?
          ItemComponent :
          (props) => (
            <>
              {props.dataItem}
            </>
          )
      }
    />
  );
}